import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Palette, PencilLine, Rocket } from 'lucide-react';
const steps = [{
  title: 'Nos contás sobre tu negocio',
  description: 'Completás un formulario breve y nos enviás logo, información, productos, servicios, fotografías y datos de contacto.',
  icon: FileText
}, {
  title: 'Diseñamos la primera versión',
  description: 'Organizamos la información y construimos una propuesta visual adaptada a tu negocio.',
  icon: Palette
}, {
  title: 'Revisamos juntos',
  description: 'Recibís la primera versión y utilizamos las dos rondas incluidas para realizar los ajustes necesarios.',
  icon: PencilLine
}, {
  title: 'Publicamos tu página',
  description: 'Conectamos el dominio, verificamos la versión móvil y dejamos tu página lista para compartir.',
  icon: Rocket
}];
export function ProcessSection() {
  return <section id="proceso" className="bg-[#050511] py-16 md:py-20" aria-labelledby="proceso-title" data-id="element-1261">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1262">
        <div className="text-center" data-id="element-1263">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-[#20d6e8]" data-id="element-1264">
            Simple y sin complicaciones
          </p>
          <h2 id="proceso-title" className="text-3xl font-bold text-white md:text-5xl" data-id="element-1265">
            De tu idea a una página publicada en cuatro pasos.
          </h2>
        </div>

        <div className="relative mt-9 grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-1266">
          <div className="absolute left-[12%] right-[12%] top-8 hidden h-px bg-gradient-to-r from-[#a738f4]/20 via-[#20d6e8]/40 to-[#e92a88]/20 lg:block" data-id="element-1267" />
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.article key={step.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="relative" data-id="element-1268">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-[#a738f4]/30 bg-[#101022] text-[#d58aff] lg:mx-0" data-id="element-1269">
                  <Icon className="h-7 w-7" data-id="element-1270" />
                </div>
                <div className="mt-5 text-center lg:text-left" data-id="element-1271">
                  <span className="text-sm font-semibold text-[#20d6e8]" data-id="element-1272">
                    Paso {index + 1}
                  </span>
                  <h3 className="mt-2 text-lg font-semibold text-white" data-id="element-1273">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#a9a9ba]" data-id="element-1274">
                    {step.description}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <p className="mx-auto mt-12 max-w-3xl rounded-xl border border-white/10 bg-[#0c0c1c] p-5 text-center text-sm leading-relaxed text-[#c9c9d6]" data-id="element-1275">
          El plazo de siete días hábiles inicia cuando recibimos toda la
          información necesaria del proyecto.
        </p>
      </div>
    </section>;
}